/* @flow */
import cx from 'classnames';
import Image from 'components/Image.jsx';
import Organization from 'entities/Organization';
import OrganizationLink from 'organizations/components/OrganizationLink.jsx';
import React from 'react';

import ux from 'styles/UX.css';
import styles from './styles/GroupOrgList-OrganizationItem.css';

class OrganizationItem extends React.Component {
  static propTypes = {
    organization: React.PropTypes.instanceOf(Organization).isRequired,
  };

  render() {
    const { organization } = this.props;
    return (
      <li className={styles.this}>
        <OrganizationLink
          className={cx('GroupOrgList-item-link', ux.highlightLink)}
          organization={organization}
          color="inherit"
          placement="right"
          alignment="top">
          <div className={styles.container}>
            <Image src={organization.getAvatarUrl()} width={24} className={styles.avatar} />
            <div className={styles.name}>
              {organization.getName()}
            </div>
          </div>
        </OrganizationLink>
      </li>
    );
  }
}

export default OrganizationItem;



// WEBPACK FOOTER //
// ./src/groups/components/GroupOrgList-OrganizationItem.jsx